import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { IFndyObject } from '@thinglogix/ngx-foundry-core';

const JSON_KEY_OFFSET = 2;

interface Attributes extends IFndyObject {
    attributes: any;
}

@Pipe({ name: 'attribute-format' })
@Injectable()
export class AttributeFormatPipe implements PipeTransform {
    transform<Type extends Attributes>(object: IFndyObject): Type {
        return Object.keys(object).reduce(
            (acc: any, key: string) => {
                if (key.startsWith('a.')) {
                    const strippedKey = key.substr(JSON_KEY_OFFSET);
                    acc.attributes[strippedKey] = object[key];
                } else {
                    acc[key] = object[key];
                }
                return acc;
            },
            { attributes: {} }
        ) as Type;
    }
}
